<template>
    <div class="verify-code" @click="generate">
        <span v-for="c,i in codeCount" :key="i"
        :style="{color: getColor(), fontWeight: getWeight(), fontStyle: getStyle(), marginRight: getRight()}"
        >{{codeChars.charAt(codeIndex[i])}}</span>
    </div>
</template>

<script type="text/babel">

export default {
    name: 'verify-code',
    props: {
        codeCount:{
            type: Number,
            default: 4
        }
    },
    data () {
        return {
            codeChars: '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
            codeBgColor: ['#fffff0', '#f0ffff', '#f0fff0', '#fff0f0'],
            codeColor: ['#FF0033', '#006699', '#993366', '#FF9900', '#66CC66', '#FF33CC'],
            codeStyle: ['font-style:italic;','margin-right: 10px;','font-weight:;',''],
            codeIndex: []
        }
    },
    methods: {
        getColor(){
            return this.codeColor[~~(Math.random()*6)]
        },
        getRight(){
            return ~~(Math.random()*2)?'5px':'0'
        },
        getStyle(){
            return ~~(Math.random()*2)?'italic':''
        },
        getWeight(){
            return ~~(Math.random()*2)?'bolder':''
        },
        generate(){
            for(let i=0;i<this.codeCount;i++){
                this.$set(this.codeIndex, i, ~~(Math.random()*this.codeChars.length))
            }
        }
    },
    created(){
        this.generate()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .verify-code{
        font-size: 20px;
        text-align: center;
        cursor: pointer;
        margin-bottom: 5px;
        width: 100px;
        height: 30px;
        background-color: rgb(240, 255, 240);
        color: rgb(102, 204, 102);
    }

</style>



// WEBPACK FOOTER //
// src/components/VerifyCode.vue